export default "__VITE_ASSET__BclepowY__"